// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoBoards, {type BoardCursorPayload, type BoardPayload} from '@app/features/konvo_board/state/KonvoBoards';
import {currentUserId} from '@app/features/konvo_scratchpad/state/ScratchpadBridge';

// Only boards somebody has opened are tracked; the rest load fresh when opened.

export function handleKonvoBoardUpdate(data: BoardPayload, _context: GatewayHandlerContext): void {
	if (!data || typeof data.board_id !== 'string' || !Array.isArray(data.elements)) return;
	KonvoBoards.peek({kind: 'personal', boardId: data.board_id})?.applyRemote(data);
}

export function handleKonvoChannelBoardUpdate(data: BoardPayload, _context: GatewayHandlerContext): void {
	if (!data || typeof data.channel_id !== 'string' || !Array.isArray(data.elements)) return;
	KonvoBoards.peek({kind: 'channel', channelId: data.channel_id})?.applyRemote(data);
}

export function handleKonvoChannelBoardCursor(data: BoardCursorPayload, _context: GatewayHandlerContext): void {
	if (!data || typeof data.channel_id !== 'string' || typeof data.user_id !== 'string') return;
	KonvoBoards.peek({kind: 'channel', channelId: data.channel_id})?.applyCursor(data, currentUserId());
}
